import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { ActionButton } from '../../ReactComponent/Modal/css';
import AlertModal from '../../ReactComponent/Modal/AlertModal';
import { P } from '../../../theme/typographySitecore';
import { CheckmarkIcon, HeaderContainer } from './css';

const ForgotPasswordSuccessModal = ({ isOpen, onClose, parentFields }) => {
  const header = () => (
    <HeaderContainer>
      <CheckmarkIcon />
      <div>{parentFields.forgotPasswordSuccessModalHeader.value}</div>
    </HeaderContainer>
  );

  const content = () => (
    <P field={parentFields.forgotPasswordSuccessModalSummary} />
  );

  const actions = () => (
    <ActionButton className="active" iconRightArrow onClick={onClose}>
      {t('Okay')}
    </ActionButton>
  );

  return (
    <AlertModal
      isOpen={isOpen}
      onClose={onClose}
      header={header}
      content={content}
      actions={actions}
    />
  );
};

ForgotPasswordSuccessModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  parentFields: PropTypes.shape({
    forgotPasswordSuccessModalHeader: PropTypes.shape({
      value: PropTypes.string,
    }),
    forgotPasswordSuccessModalSummary: PropTypes.object,
  }),
};

export default ForgotPasswordSuccessModal;
